import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { api, formatApiErrorDetail } from "@/lib/api";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/admin/login", { email: email.trim().toLowerCase(), password });
      localStorage.setItem("mf_admin_token", data.token);
      localStorage.setItem("mf_admin_user", JSON.stringify(data.user));
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err?.response?.data?.detail) || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 mx-auto w-full max-w-md px-6 py-24">
        <p className="overline">Admin</p>
        <h1 className="font-serif text-4xl mt-6">Sign in</h1>
        <p className="mt-4 text-[hsl(var(--plum-soft))]">Access submissions and goal insights.</p>

        <form onSubmit={onSubmit} className="mt-12 grid gap-8">
          <div>
            <label className="overline block mb-2" htmlFor="admin-email">Email</label>
            <input
              id="admin-email"
              type="email"
              data-testid="admin-email-input"
              className="input-editorial"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <label className="overline block mb-2" htmlFor="admin-password">Password</label>
            <input
              id="admin-password"
              type="password"
              data-testid="admin-password-input"
              className="input-editorial"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button
            type="submit"
            disabled={busy}
            data-testid="admin-login-submit"
            className="btn-primary disabled:opacity-40 mt-4"
          >
            {busy ? "Signing in…" : "Sign in"} <ArrowRight size={16} strokeWidth={1.5} />
          </button>
        </form>
      </main>
      <Footer />
    </div>
  );
}
